function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var e = g(require("tiny-invariant")),
    t = require("react"),
    n = t.Children,
    r = t.cloneElement,
    o = t.Component,
    i = t.createElement,
    l = t.createRef,
    a = g(require("classnames")),
    c = require("sortablejs"),
    s = g(c);

exports.Sortable = s;
var u = c.Direction;
exports.Direction = u;
var f = c.DOMRect;
exports.DOMRect = f;
var p = c.GroupOptions;
exports.GroupOptions = p;
var d = c.MoveEvent;
exports.MoveEvent = d;
var b = c.Options;
exports.Options = b;
var y = c.PullResult;
exports.PullResult = y;
var v = c.PutResult;
exports.PutResult = v;
var h = c.SortableEvent;
exports.SortableEvent = h;
var m = c.SortableOptions;
exports.SortableOptions = m;
var O = c.Utils;

function g(e) {
  return e && e.__esModule ? e["default"] : e;
}

function w(e, t) {
  if (null == e) return {};

  var n,
      r,
      o = function (e, t) {
    if (null == e) return {};
    var n,
        r,
        o = {},
        i = Object.keys(e);

    for (r = 0; r < i.length; r++) {
      n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
    }

    return o;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);

    for (r = 0; r < i.length; r++) {
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
    }
  }

  return o;
}

function S(e) {
  return function (e) {
    if (Array.isArray(e)) return j(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
  }(e) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return j(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === n && e.constructor && (n = e.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(e);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return j(e, t);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function j(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

function x(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function I(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? x(Object(n), !0).forEach(function (t) {
      P(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : x(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function P(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function E(e) {
  null !== e.parentElement && e.parentElement.removeChild(e);
}

function k(e) {
  e.forEach(function (e) {
    return E(e.element);
  });
}

function C(e) {
  e.forEach(function (e) {
    var t, n, r, o;
    t = e.parentElement, n = e.element, r = e.oldIndex, o = t.children[r] || null, t.insertBefore(n, o);
  });
}

function D(e, t) {
  var n = M(e),
      r = {
    parentElement: e.from
  },
      o = [];

  switch (n) {
    case "normal":
      o = [{
        element: e.item,
        newIndex: e.newIndex,
        oldIndex: e.oldIndex,
        parentElement: e.from
      }];
      break;

    case "swap":
      o = [I({
        element: e.item,
        oldIndex: e.oldIndex,
        newIndex: e.newIndex
      }, r), I({
        element: e.swapItem,
        oldIndex: e.newIndex,
        newIndex: e.oldIndex
      }, r)];
      break;

    case "multidrag":
      o = e.oldIndicies.map(function (t, n) {
        return I({
          element: t.multiDragElement,
          oldIndex: t.index,
          newIndex: e.newIndicies[n].index
        }, r);
      });
  }

  return function (e, t) {
    return e.map(function (e) {
      return I(I({}, e), {}, {
        item: t[e.oldIndex]
      });
    }).sort(function (e, t) {
      return e.oldIndex - t.oldIndex;
    });
  }(o, t);
}

function A(e, t) {
  var n = S(t);
  return e.concat().reverse().forEach(function (e) {
    return n.splice(e.oldIndex, 1);
  }), n;
}

function R(e, t, n, r) {
  var o = S(t);
  return e.forEach(function (e) {
    var t = r && n && r(e.item, n);
    o.splice(e.newIndex, 0, t || e.item);
  }), o;
}

function M(e) {
  return e.oldIndicies && e.oldIndicies.length > 0 ? "multidrag" : e.swapItem ? "swap" : "normal";
}

function U(e) {
  return (U = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}

function L(e) {
  return function (e) {
    if (Array.isArray(e)) return _(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
  }(e) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return _(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === n && e.constructor && (n = e.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(e);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _(e, t);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function _(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

function H(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function N(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? H(Object(n), !0).forEach(function (t) {
      B(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : H(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function q(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function T(e, t) {
  return (T = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function F(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = $(e);

    if (t) {
      var o = $(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return G(this, n);
  };
}

function G(e, t) {
  return !t || "object" !== U(t) && "function" != typeof t ? function (e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }(e) : t;
}

function $(e) {
  return ($ = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function B(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

exports.Utils = O;

var J = {
  dragging: null
},
    z = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && T(e, t);
  }(d, o);
  var c,
      u,
      f,
      p = F(d);

  function d(t) {
    var n;
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, d), (n = p.call(this, t)).ref = l();
    var r = t.list.map(function (e) {
      return N(N({}, e), {}, {
        chosen: !1,
        selected: !1
      });
    });
    return t.setList(r, n.sortable, J), e(!t.plugins, '\nPlugins prop is no longer supported.\nInstead, mount it with "Sortable.mount(new MultiDrag())"\nPlease read the updated README.md at https://github.com/SortableJS/react-sortablejs.\n      '), n;
  }

  return c = d, (u = [{
    key: "componentDidMount",
    value: function value() {
      if (null !== this.ref.current) {
        var e = this.makeOptions();
        s.create(this.ref.current, e);
      }
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.tag,
          n = {
        style: e.style,
        className: e.className,
        id: e.id
      };
      return i(t && null !== t ? t : "div", N({
        ref: this.ref
      }, n), this.getChildren());
    }
  }, {
    key: "getChildren",
    value: function value() {
      var e = this.props,
          t = e.children,
          o = e.dataIdAttr,
          i = e.selectedClass,
          l = void 0 === i ? "sortable-selected" : i,
          c = e.chosenClass,
          s = void 0 === c ? "sortable-chosen" : c,
          u = (e.dragClass, e.fallbackClass, e.ghostClass, e.swapClass, e.filter),
          f = void 0 === u ? "sortable-filter" : u,
          p = e.list;
      if (!t || null == t) return null;
      var d = o || "data-id";
      return n.map(t, function (e, t) {
        var n,
            o,
            i = p[t],
            c = e.props.className,
            u = "string" == typeof f && B({}, f.replace(".", ""), !!i.filtered),
            b = a(c, N((B(n = {}, l, i.selected), B(n, s, i.chosen), n), u));
        return r(e, (B(o = {}, d, e.key), B(o, "className", b), o));
      });
    }
  }, {
    key: "makeOptions",
    value: function value() {
      var e,
          t = this,
          n = ((e = this.props).list, e.setList, e.children, e.tag, e.style, e.className, e.clone, e.onAdd, e.onChange, e.onChoose, e.onClone, e.onEnd, e.onFilter, e.onRemove, e.onSort, e.onStart, e.onUnchoose, e.onUpdate, e.onMove, e.onSpill, e.onSelect, e.onDeselect, w(e, ["list", "setList", "children", "tag", "style", "className", "clone", "onAdd", "onChange", "onChoose", "onClone", "onEnd", "onFilter", "onRemove", "onSort", "onStart", "onUnchoose", "onUpdate", "onMove", "onSpill", "onSelect", "onDeselect"]));
      return ["onAdd", "onChoose", "onDeselect", "onEnd", "onRemove", "onSelect", "onSpill", "onStart", "onUnchoose", "onUpdate"].forEach(function (e) {
        return n[e] = t.prepareOnHandlerPropAndDOM(e);
      }), ["onChange", "onClone", "onFilter", "onSort"].forEach(function (e) {
        return n[e] = t.prepareOnHandlerProp(e);
      }), N(N({}, n), {}, {
        onMove: function onMove(e, n) {
          var r = t.props.onMove,
              o = e.willInsertAfter || -1;
          if (!r) return o;
          var i = r(e, n, t.sortable, J);
          return void 0 !== i && i;
        }
      });
    }
  }, {
    key: "prepareOnHandlerPropAndDOM",
    value: function value(e) {
      var t = this;
      return function (n) {
        t.callOnHandlerProp(n, e), t[e](n);
      };
    }
  }, {
    key: "prepareOnHandlerProp",
    value: function value(e) {
      var t = this;
      return function (n) {
        t.callOnHandlerProp(n, e);
      };
    }
  }, {
    key: "callOnHandlerProp",
    value: function value(e, t) {
      var n = this.props[t];
      n && n(e, this.sortable, J);
    }
  }, {
    key: "onAdd",
    value: function value(e) {
      var t = this.props,
          n = t.list,
          r = t.setList,
          o = t.clone,
          i = D(e, L(J.dragging.props.list));
      k(i), r(R(i, n, e, o).map(function (e) {
        return N(N({}, e), {}, {
          selected: !1
        });
      }), this.sortable, J);
    }
  }, {
    key: "onRemove",
    value: function value(t) {
      var n = this,
          r = this.props,
          o = r.list,
          i = r.setList,
          l = M(t),
          a = D(t, o);
      C(a);
      var c = L(o);
      if ("clone" !== t.pullMode) c = A(a, c);else {
        var s = a;

        switch (l) {
          case "multidrag":
            s = a.map(function (e, n) {
              return N(N({}, e), {}, {
                element: t.clones[n]
              });
            });
            break;

          case "normal":
            s = a.map(function (e) {
              return N(N({}, e), {}, {
                element: t.clone
              });
            });
            break;

          case "swap":
          default:
            e(!0, 'mode "'.concat(l, '" cannot clone. Please remove "props.clone" from <ReactSortable/> when using the "').concat(l, '" plugin'));
        }

        k(s), a.forEach(function (e) {
          var r = e.oldIndex,
              o = n.props.clone(e.item, t);
          c.splice(r, 1, o);
        });
      }
      i(c = c.map(function (e) {
        return N(N({}, e), {}, {
          selected: !1
        });
      }), this.sortable, J);
    }
  }, {
    key: "onUpdate",
    value: function value(e) {
      var t = this.props,
          n = t.list,
          r = t.setList,
          o = D(e, n);
      return k(o), C(o), r(function (e, t) {
        return R(e, A(e, t));
      }(o, n), this.sortable, J);
    }
  }, {
    key: "onStart",
    value: function value() {
      J.dragging = this;
    }
  }, {
    key: "onEnd",
    value: function value() {
      J.dragging = null;
    }
  }, {
    key: "onChoose",
    value: function value(e) {
      var t = this.props,
          n = t.list;
      (0, t.setList)(n.map(function (t, n) {
        return n === e.oldIndex ? N(N({}, t), {}, {
          chosen: !0
        }) : t;
      }), this.sortable, J);
    }
  }, {
    key: "onUnchoose",
    value: function value(e) {
      var t = this.props,
          n = t.list;
      (0, t.setList)(n.map(function (t, n) {
        return n === e.oldIndex ? N(N({}, t), {}, {
          chosen: !1
        }) : t;
      }), this.sortable, J);
    }
  }, {
    key: "onSpill",
    value: function value(e) {
      var t = this.props,
          n = t.removeOnSpill,
          r = t.revertOnSpill;
      n && !r && E(e.item);
    }
  }, {
    key: "onSelect",
    value: function value(e) {
      var t = this.props,
          n = t.list,
          r = t.setList,
          o = n.map(function (e) {
        return N(N({}, e), {}, {
          selected: !1
        });
      });
      e.newIndicies.forEach(function (t) {
        var n = t.index;
        if (-1 === n) return console.log('"'.concat(e.type, '" had indice of "').concat(t.index, "\", which is probably -1 and doesn't usually happen here.")), void console.log(e);
        o[n].selected = !0;
      }), r(o, this.sortable, J);
    }
  }, {
    key: "onDeselect",
    value: function value(e) {
      var t = this.props,
          n = t.list,
          r = t.setList,
          o = n.map(function (e) {
        return N(N({}, e), {}, {
          selected: !1
        });
      });
      e.newIndicies.forEach(function (e) {
        var t = e.index;
        -1 !== t && (o[t].selected = !0);
      }), r(o, this.sortable, J);
    }
  }, {
    key: "sortable",
    get: function get() {
      var e = this.ref.current;
      if (null === e) return null;
      var t = Object.keys(e).find(function (e) {
        return e.includes("Sortable");
      });
      return t ? e[t] : null;
    }
  }]) && q(c.prototype, u), f && q(c, f), d;
}();

exports.ReactSortable = z, B(z, "defaultProps", {
  clone: function clone(e) {
    return e;
  }
});